import { Input } from '@material-ui/core';
import React, { Component } from 'react';
import injectSheet from 'react-jss/lib/injectSheet';
import { connect } from 'react-redux';

import SearchResults from './SearchResults';

import * as bucketSelectors from '../../selectors/bucketSelectors';
import * as assetSelectors from '../../selectors/assetSelectors';
import * as assetConstants from '../../constants/assets';
import AssetSearchStartAdornment from './AssetSearchStartAdornment';
import AssetSearchEndAdornment from './AssetSearchEndAdornment';
import * as searchSelectors from '../../selectors/searchSelectors';

class AssetSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            focus: false,
            searchTerm: '',
            showTags: false,
        };

        this.searchResultsRef = React.createRef();
        this.inputRef = React.createRef();
    }

    componentDidUpdate(previousProps) {
        if (previousProps.application !== this.props.application) {
            this.onClearSearch();
        }
    }

    componentDidMount() {
        if (this.props.selectedTags.length || this.props.searchTerm !== '') {
            this.onClearSearchState();
        }
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = event => {
        const isClickInsideInput =
            this.inputRef.current &&
            this.inputRef.current.contains(event.target);

        if (isClickInsideInput) {
            this.setState({ focus: true });
        } else if (
            this.state.focus &&
            this.searchResultsRef.current &&
            !this.searchResultsRef.current.contains(event.target)
        ) {
            this.setState({ focus: false });
        }
    };

    selectTag = tag => {
        this.props.onSetSelectedTags([...this.props.selectedTags, tag]);

        this.props.onSearchProjects({
            bucketId: this.props.bucket.id,
            application: this.props.application,
        });
    }

    handleSearchChange = event => {
        this.setState({ searchTerm: event.target.value });
    };

    handleShowTags = () => {
        this.setState({ showTags: true });
    };

    setSearchResultsRef = element => {
        this.searchResultsRef.current = element;
    };

    onEnter = (event) => {
        if (event.key !== 'Enter') {
            return;
        }

        this.props.onSetSelectedSearchTerm(this.state.searchTerm);

        this.props.onSearchProjects({
            bucketId: this.props.bucket.id,
            application: this.props.application,
        });
    };

    onClearSearchState = () => {
        const { bucket, application, onSetSelectedTags, onSetSelectedSearchTerm, onSearchProjects } = this.props;
        onSetSelectedTags([]);
        onSetSelectedSearchTerm('');
        onSearchProjects({
            bucketId: bucket.id,
            application: application,
        });
    }

    onClearSearch = () => {
        this.setState({
            searchTerm: '',
            showTags: false
        }, this.onClearSearchState);
    }
    
    render() {
        const { classes, selectedTags } = this.props;

        return (
            <div className={classes.container}>
                <Input
                    placeholder="Search"
                    startAdornment={<AssetSearchStartAdornment selectedTags={selectedTags} />}
                    endAdornment={<AssetSearchEndAdornment
                        search={this.state.searchTerm}
                        selectedTags={selectedTags}
                        onClearSearch={this.onClearSearch}
                    />}
                    className={
                        classes.input +
                        (this.state.focus ? ' ' + classes.inputFocus : '')
                    }
                    disableUnderline
                    inputProps={{
                        ref: this.inputRef,
                    }}
                    onChange={this.handleSearchChange}
                    value={this.state.searchTerm}
                    onKeyDown={this.onEnter}
                />
                {this.state.focus && (
                    <SearchResults
                        setSearchResultsRef={this.setSearchResultsRef}
                        showTags={this.state.showTags}
                        handleShowTags={this.handleShowTags}
                        selectTag={this.selectTag}
                        selectedTags={selectedTags}
                    />
                )}
            </div>
        );
    }
}

const style = () => ({
    container: {
        position: 'relative',
        marginRight: '20px',
        marginLeft: '20px',
        flexGrow: 1,
    },
    input: {
        minHeight: '38px',
        borderRadius: '4px',
        border: '1px solid #e2e2e2',
        background: 'rgb(245, 246, 247)',
        color: 'rgba(33, 33, 33, 0.87)',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '10px',
        paddingRight: '10px',
        width: 'auto',
    },
    inputFocus: {
        background: 'rgb(255, 255, 255)',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 1px 1px',
    }
});

const mapStateToProps = state => ({
    bucket: bucketSelectors.getBucket(state),
    application: assetSelectors.getApplication(state),
    selectedTags: searchSelectors.getAssetSearchSelectedTags(state),
    searchTerm: searchSelectors.getAssetSearchTerm(state),
});

const mapDispatchToProps = dispatch => ({
    onSearchProjects: (tags) => {
        dispatch({ type: assetConstants.FETCH_ASSETS_REQUEST, payload: tags });
    },
    onSetSelectedSearchTerm: (searchTerm) => {
        dispatch({ type: assetConstants.SET_ASSET_SEARCH_TERM, payload: searchTerm });
    },
    onSetSelectedTags: (tags) => {
        dispatch({ type: assetConstants.SET_ASSET_SEARCH_SELECTED_TAGS, payload: tags });
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectSheet(style)(AssetSearch));



// WEBPACK FOOTER //
// ./src/components/search/AssetSearch.js